export default __webpack_public_path__ + "static/vue-f9e57c613665512559b017097fd772de.svg";